<div class="row">
  <form #createSalesOrderForm="ngForm">
    <nb-card accent="info">
      <nb-card-header class="text-center clear-fix">
        <button
          nbButton
          outline
          size="tiny"
          status="info"
          class="float-end"
          (click)="cancel(createSalesOrderForm.form.dirty)"
        >
          x
        </button>
        <br />
        <div *ngIf="salesOrderUUID">Edit Sales Order</div>
        <div *ngIf="!salesOrderUUID">New Sales Order</div>
      </nb-card-header>
      <nb-card-body>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="insurgoOrderNumberInput" class="label" required
                >Insurgo Order Number</label
              >
              <input
                type="text"
                nbInput
                fullWidth
                required
                [status]="displayFieldCss(createSalesOrderForm, insurgoOrderNumberInput)"
                maxlength="50"
                id="insurgoOrderNumberInput"
                name="insurgoOrderNumberInput"
                [(ngModel)]="salesOrder.insurgoOrderNumber"
                #insurgoOrderNumberInput="ngModel"
                fieldSize="small"
              />
              <app-form-field-error
                [displayError]="insurgoOrderNumberInput.touched && insurgoOrderNumberInput.invalid"
                [displaySuccess]="insurgoOrderNumberInput.valid"
                errorMsg="Insurgo Order Number is required"
              ></app-form-field-error>
            </div>
            <div class="mb-3">
              <label for="customerOrderNumberInput" class="label"
                >Customer Order Number</label
              >
              <input
                type="text"
                nbInput
                fullWidth
                required
                [status]="displayFieldCss(createSalesOrderForm, customerOrderNumberInput)"
                maxlength="50"
                id="customerOrderNumberInput"
                name="customerOrderNumberInput"
                [(ngModel)]="salesOrder.customerOrderNumber"
                #customerOrderNumberInput="ngModel"
                fieldSize="small"
              />
              <app-form-field-error
                [displayError]="customerOrderNumberInput.touched && customerOrderNumberInput.invalid"
                [displaySuccess]="customerOrderNumberInput.valid"
                errorMsg="Customer Order Number is required"
              ></app-form-field-error>
            </div>
            <div class="mb-3">
              <label for="customerIDInput" class="label">Customer</label>
              <app-company-selector
                id="customerIDInput"
                name="customerIDInput"
                required
                [(ngModel)]="salesOrder.customerID"
                #typeInput="ngModel"
              ></app-company-selector>
              <!-- <app-form-field-error [displayError]="customerIDInput.touched && customerIDInput.invalid" [displaySuccess]="customerIDInput.valid" errorMsg="Customer is required"></app-form-field-error> -->
            </div>
            <div class="mb-3">
              <label for="deliveryCostInput" class="label">Delivery Cost</label>
              <nb-form-field fieldSize="small">
                <span nbPrefix>{{currencySymbol}}</span>
                <input
                  nbInput
                  type="number"
                  required
                  min="0"
                  step="0.01"
                  id="deliveryCostInput"
                  name="deliveryCostInput"
                  maxlength="50"
                  [(ngModel)]="salesOrder.deliveryCost"
                  #deliveryCostInput="ngModel"
                  [status]="displayFieldCss(createSalesOrderForm, deliveryCostInput)"
                  (blur)="formatDeliveryCost()"
                />
              </nb-form-field>
              <app-form-field-error
                [displayError]="deliveryCostInput.touched && deliveryCostInput.invalid"
                [displaySuccess]="deliveryCostInput.valid"
                errorMsg="Delivery cost is required"
              ></app-form-field-error>
            </div>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer class="clear-fix">
        <div class="alert alert-danger" *ngIf="formError.error">
          Creating Sales Order failed...
        </div>
        <div class="alert alert-success" *ngIf="formError.success">
          Saving Sales Order was successful!
        </div>
        <button
          *ngIf="salesOrderUUID"
          nbButton
          outline
          status="success"
          [disabled]="createSalesOrderForm.invalid || formError.submitting || !createSalesOrderForm.dirty"
          type="submit"
          value="submit"
          (click)="submit()"
          class="float-end"
        >
          Save
        </button>
        <button
          *ngIf="!salesOrderUUID"
          nbButton
          outline
          status="success"
          [disabled]="createSalesOrderForm.invalid || formError.submitting || !createSalesOrderForm.dirty"
          type="submit"
          value="submit"
          (click)="submit()"
          class="float-end"
        >
          Add
        </button>
        <button
          nbButton
          outline
          status="danger"
          *ngIf="createSalesOrderForm.dirty || createSalesOrderForm.dirty && !formError.submitting"
          class="float-start"
          (click)="cancel(createSalesOrderForm.form.dirty)"
        >
          Cancel
        </button>
      </nb-card-footer>
    </nb-card>
  </form>
</div>
